const pluralKeys = ['=0', 'one', 'other'] as const;

const unescapedPipePattern = /(?<!\\)\|/g;
const escapedPipePattern = /\\\|/g;

const buildIcuString = (plural: string) => `{count, plural, ${plural}}`;

export const keysToIcuPlural = <TKeys extends string>(
  defaultMessages: Record<TKeys, string>,
  localeMessages?: Record<string, string>,
): typeof defaultMessages => {
  const result = {} as typeof defaultMessages;

  for (const key in defaultMessages) {
    const value = localeMessages?.[key] ?? defaultMessages[key];

    if (unescapedPipePattern.test(value)) {
      const pluralsArray = value.split(unescapedPipePattern).map((part) => part.replace(escapedPipePattern, '|'));

      if (pluralsArray.length > pluralKeys.length) {
        throw new Error(`Plural keys length longer than expected for ${key}`);
      }

      const plural = pluralsArray.reduce((acc, plural, index, { length }) => {
        const pluralKeyIndex = index === length - 1 ? 2 : index;
        const pluralKey = pluralKeys[pluralKeyIndex];
        return `${acc}${pluralKey} {${plural.trim()}} `;
      }, '');

      result[key] = buildIcuString(plural.trim());
    } else {
      result[key] = value.replace(escapedPipePattern, '|');
    }
  }

  return result;
};
